/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespCollectionSpotlightItem_item = {
    readonly title: string | null;
    readonly linkData: {
        readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
    };
    readonly image: {
        readonly imageUrl: string | null;
        readonly imageWidth: string | null;
        readonly imageHeight: string | null;
    } | null;
    readonly " $refType": "HpRespCollectionSpotlightItem_item";
};
export type HpRespCollectionSpotlightItem_item$data = HpRespCollectionSpotlightItem_item;
export type HpRespCollectionSpotlightItem_item$key = {
    readonly " $data"?: HpRespCollectionSpotlightItem_item$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespCollectionSpotlightItem_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespCollectionSpotlightItem_item",
  "type": "CollectionSpotlightItem",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "linkData",
      "storageKey": null,
      "args": null,
      "concreteType": "LinkData",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "SeoLink_linkData",
          "args": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "image",
      "storageKey": null,
      "args": null,
      "concreteType": "CollectionSpotlightImageType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageUrl",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageWidth",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "imageHeight",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '51cd4e490ad619148ef58958178319f0';
export default node;
